import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23a18be0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plaque-dynamics__container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Динамика")
], -1))
const _hoisted_3 = { class: "plaque-dynamics__table-container" }
const _hoisted_4 = {
  key: 0,
  class: "plaque-dynamics__organization_info"
}
const _hoisted_5 = { class: "plaque-dynamics__organization_info_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Название", -1))
const _hoisted_7 = { class: "plaque-dynamics__organization_info_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ИНН", -1))
const _hoisted_9 = { class: "plaque-dynamics__organization_info_item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Телефон", -1))
const _hoisted_11 = { class: "plaque-dynamics__organization_info_item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Сайт", -1))
const _hoisted_13 = { class: "plaque-dynamics__organization_info_item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Адрес", -1))
const _hoisted_15 = { class: "plaque-dynamics__organization_info_item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Статус", -1))
const _hoisted_17 = { class: "plaque-dynamics__organization_info_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Длительность подписки", -1))
const _hoisted_19 = { class: "plaque-dynamics__organization_info_item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Дата договора", -1))
const _hoisted_21 = { class: "plaque-dynamics__organization_info_item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Дата последней оплаты", -1))
const _hoisted_23 = { class: "plaque-dynamics__organization_info_item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Дата следующей оплаты", -1))
const _hoisted_25 = { class: "plaque-dynamics__table-header" }
const _hoisted_26 = { class: "plaque-dynamics__input-container" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Организация:", -1))
const _hoisted_28 = { class: "plaque-dynamics__input-container" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Отображать по:", -1))
const _hoisted_30 = { class: "plaque-dynamics__input-container" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Архивные:", -1))
const _hoisted_32 = { class: "plaque-dynamics__info-button" }
const _hoisted_33 = { class: "plaque-dynamics__month-name" }
const _hoisted_34 = { class: "plaque-dynamics__subheader" }
const _hoisted_35 = { class: "plaque-dynamics__number-cell" }
const _hoisted_36 = { class: "plaque-dynamics__subheader" }
const _hoisted_37 = { class: "plaque-dynamics__subheader" }
const _hoisted_38 = { class: "plaque-dynamics__subheader" }
const _hoisted_39 = { class: "plaque-dynamics__number-cell" }
const _hoisted_40 = { class: "plaque-dynamics__subheader" }
const _hoisted_41 = { class: "plaque-dynamics__number-cell" }

import { organizationsApi, statisticApi } from '@/shared/api'
import { OrganizationDynamicsType } from '@/shared/types/statistic.type'
import { showErrorMessage } from '@/shared/utils/errors'
import { computed, onMounted, ref, toRaw, watch } from 'vue'
import ru from 'element-plus/es/locale/lang/ru'
import { tariffsApi } from '@/shared/api/admin/tariffs.api'
import { useUser } from '@/shared/composables'
import {
  OrganizationStatus,
  OrganizationSubscription,
  OrganizationType,
} from '@/shared/types'
import {
  ORGANIZATION_STATUSES,
  ORGANIZATION_SUBSCRIPTIONS,
} from '@/shared/constants/organization'
import { ElTable } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tableRef = ref<InstanceType<typeof ElTable> | null>(null)
const data = ref<OrganizationDynamicsType[]>([])
const organizationData = ref<OrganizationType>(null)
const loading = ref(false)
const showArchive = ref(false)
const currentPage = ref(1)
const countOnPage = ref(10)
const monthCount = ref(6)
const subscriptionType = ref<OrganizationSubscription>(null)
const totalOrganizationCount = ref(0)
const organizationName = ref(null)
const months = ref([])
const tariffTitle = ref(null)
const tariffList = ref([])
const sortingType = ref(null)
const { user } = useUser()
const extraColumns = ref([])
const status = ref<OrganizationStatus>('supported')
const sortedColumnDate = ref<string>(null)
const sortedColumnField = ref<string>(null)
const sortedColumnOrder = ref<string>(null)

const offset = computed(() => countOnPage.value * (currentPage.value - 1))

const getData = async () => {
  loading.value = true

  const [error, response] = await statisticApi.getPlaqueDynamics(
    countOnPage.value,
    offset.value,
    tariffTitle.value,
    sortingType.value,
    organizationName.value,
    monthCount.value,
    status.value,
    showArchive.value,
    subscriptionType.value,
    sortedColumnDate.value,
    sortedColumnField.value,
    sortedColumnOrder.value
  )

  if (error) {
    showErrorMessage(error)
    loading.value = false

    return
  }

  months.value = response.data.dates
  data.value = [...response.data.organizations, response.data.summary]
  totalOrganizationCount.value = response.data.totalOrganizationCount

  loading.value = false
}

const getTariffs = async (): Promise<void> => {
  if (user.value.role != 'admin') {
    return
  }

  loading.value = true

  const [error, response] = await tariffsApi.getTariffsList()

  if (error) {
    showErrorMessage(error)
  } else {
    tariffList.value = response.data.tariffs
  }

  loading.value = false
}

const getRowClassName = (row: any) => {
  if (row.row.need_tariff_update) {
    return 'white-row-bold-light'
  }

  if (row.rowIndex === 0 && currentPage.value === 1) {
    return 'white-row-bold'
  }

  if (row.rowIndex === data.value.length - 1) {
    return 'white-row-summary'
  }

  return 'white-row'
}

const getFormattedDate = (date: string) => {
  const localized = new Date(date).toLocaleString('ru', {
    year: 'numeric',
    month: 'long',
  })

  return localized.charAt(0).toUpperCase() + localized.slice(1)
}

const getRowTotalNumber = (row: any) => {
  if (toRaw(row).name.startsWith('Всего')) {
    return ''
  }

  return (
    data.value.indexOf(toRaw(row)) +
    1 +
    (currentPage.value - 1) * countOnPage.value
  )
}

const getExpenditureDisplayPrice = (row: any, month: string) => {
  if (!row.expenditures[month]) {
    return 'no stats!'
  }

  if (
    (row.subscription_type === 'yearly' ||
      row.subscription_type === 'trimonthly') &&
    row.tariff &&
    !row.last_payment_date
  ) {
    return 'Дата опл.'
  }

  if (!row.expenditures[month].is_payment_month && !row.is_summary) {
    return '-'
  }

  return row.expenditures[month].factual_price
}

const getExpenditurePriceClass = (row: any, month: string) => {
  if (
    (row.subscription_type === 'yearly' ||
      row.subscription_type === 'trimonthly') &&
    row.tariff &&
    !row.last_payment_date
  ) {
    return 'plaque-dynamics__number-cell_bad'
  }

  return 'plaque-dynamics__number-cell'
}

const getExpenditureSubclass = (row: any, month: string) => {
  const rawRow = toRaw(row)
  const rawExpenditures = rawRow.expenditures[month]

  if (!rawExpenditures) {
    return 'plaque-dynamics__neutral'
  }

  if (rawRow.is_summary) {
    return 'plaque-dynamics__summary'
  }

  if (rawExpenditures.dynamics > 0) {
    return 'plaque-dynamics__good'
  } else if (rawExpenditures.dynamics < 0) {
    return 'plaque-dynamics__bad'
  }

  return 'plaque-dynamics__neutral'
}

const getNextPaymentDate = (organization: OrganizationType) => {
  if (!organization.last_payment_date) {
    return '-'
  }

  const lastPaymentDate = new Date(organization.last_payment_date)
  let newPaymentDate = null

  switch (organization.subscription_type) {
    case 'yearly':
      newPaymentDate = new Date(
        lastPaymentDate.getFullYear() + 1,
        lastPaymentDate.getMonth(),
        lastPaymentDate.getDate()
      )
      break
    case 'trimonthly':
      newPaymentDate = new Date(
        lastPaymentDate.getFullYear(),
        lastPaymentDate.getMonth() + 3,
        lastPaymentDate.getDate()
      )
      break
    default:
      newPaymentDate = new Date(
        lastPaymentDate.getFullYear(),
        lastPaymentDate.getMonth(),
        lastPaymentDate.getDate() + 1
      )
  }

  return newPaymentDate.toISOString().slice(0, 10)
}

const handleChangeCurrentPage = (page: number): void => {
  currentPage.value = page

  getData()
}

const onCellClick = async (row: any, column: any) => {
  const rawRow = toRaw(row)
  const rawColumn = toRaw(column)

  if (rawColumn.property === 'name' && rawRow.id) {
    loading.value = true
    const [error, response] = await organizationsApi.getOrganizationInfo(
      rawRow.id
    )
    loading.value = false

    if (error) {
      showErrorMessage(error)
      return
    }

    organizationData.value = response.data.organization
  }
}

const clearSorting = () => {
  sortedColumnDate.value = null
  sortedColumnField.value = null
  sortedColumnOrder.value = null

  if (tableRef.value) {
    tableRef.value.clearSort()
  } else {
    console.error('Dynamics table ref null')
  }
}

const clearOrganizationData = () => (organizationData.value = null)

const sortByColumn = ({ column, prop, order }) => {
  sortedColumnOrder.value = order

  if (sortedColumnOrder.value) {
    const split = prop.split('.')
    sortedColumnDate.value = split[1]
    sortedColumnField.value = split[2]
  } else {
    sortedColumnDate.value = null
    sortedColumnField.value = null
  }

  getData()
}

watch(tariffTitle, getData)
watch(sortingType, getData)
watch(status, getData)
watch(showArchive, getData)
watch(subscriptionType, getData)
watch(monthCount, () => {
  clearSorting()
  getData()
})
watch(extraColumns, clearSorting)

onMounted(() => {
  getData()
  getTariffs()
})

return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (organizationData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_icon_template, {
              class: "plaque-dynamics__close-popup",
              height: "24",
              name: "close",
              width: "24",
              onClick: clearOrganizationData
            }),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", null, _toDisplayString(organizationData.value.name), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", null, _toDisplayString(organizationData.value.inn), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", null, _toDisplayString(organizationData.value.phone), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", null, _toDisplayString(organizationData.value.site), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", null, _toDisplayString(organizationData.value.address), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("span", null, _toDisplayString(_unref(ORGANIZATION_STATUSES)[organizationData.value.status]), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("span", null, _toDisplayString(_unref(ORGANIZATION_SUBSCRIPTIONS)[organizationData.value.subscription_type]), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("span", null, _toDisplayString(organizationData.value.deal_date ? organizationData.value.deal_date : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("span", null, _toDisplayString(organizationData.value.last_payment_date
                ? organizationData.value.last_payment_date
                : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("span", null, _toDisplayString(getNextPaymentDate(organizationData.value)), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_config_provider, { locale: _unref(ru) }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_unref(ElTable), {
            class: "table",
            ref_key: "tableRef",
            ref: tableRef,
            onCellClick: onCellClick,
            "row-class-name": getRowClassName,
            onSortChange: sortByColumn,
            "cell-class-name": "white-cell",
            "max-height": "750",
            data: data.value,
            "default-sort": { prop: 'countTotal', order: 'descending' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, null, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createVNode(_component_el_input, {
                        clearable: "",
                        onChange: getData,
                        modelValue: organizationName.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((organizationName).value = $event)),
                        controls: false
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_el_select, {
                      clearable: "",
                      placeholder: "Тариф",
                      modelValue: tariffTitle.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tariffTitle).value = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tariffList.value, (tariff) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            value: tariff.title,
                            label: tariff.display_title
                          }, null, 8, ["value", "label"]))
                        }), 256)),
                        _createVNode(_component_el_option, {
                          value: "no_tariff",
                          label: "Без тарифа"
                        }),
                        _createVNode(_component_el_option, {
                          value: "custom",
                          label: "Индивидуальный"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_select, {
                      clearable: "",
                      placeholder: "Тип",
                      modelValue: status.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((status).value = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ORGANIZATION_STATUSES), (statusName, statusKey) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            value: statusKey,
                            label: statusName
                          }, null, 8, ["value", "label"]))
                        }), 256)),
                        _createVNode(_component_el_option, {
                          value: "no_type",
                          label: "Без типа"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_select, {
                      clearable: "",
                      placeholder: "Сортировка",
                      modelValue: sortingType.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((sortingType).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "null",
                          label: "По отчетам"
                        }),
                        _createVNode(_component_el_option, {
                          value: "overdraft",
                          label: "Макс. перерасход"
                        }),
                        _createVNode(_component_el_option, {
                          value: "worst_dynamics",
                          label: "Негативная динамика"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_select, {
                      clearable: "",
                      placeholder: "Глубина поиска",
                      modelValue: monthCount.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((monthCount).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: 3,
                          label: "3 месяца"
                        }),
                        _createVNode(_component_el_option, {
                          value: 6,
                          label: "6 месяцев"
                        }),
                        _createVNode(_component_el_option, {
                          value: 12,
                          label: "12 месяцев"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_select, {
                      clearable: "",
                      placeholder: "Подписка",
                      modelValue: subscriptionType.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((subscriptionType).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "monthly",
                          label: "Месячная"
                        }),
                        _createVNode(_component_el_option, {
                          value: "yearly",
                          label: "Годовая"
                        }),
                        _createVNode(_component_el_option, {
                          value: "trimonthly",
                          label: "Трехмесячная"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_select, {
                      clearable: "",
                      multiple: "",
                      "collapse-tags": "",
                      placeholder: "Доп. колонки",
                      modelValue: extraColumns.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((extraColumns).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "factual_price",
                          label: "Стоимость"
                        }),
                        _createVNode(_component_el_option, {
                          value: "overdraft_price",
                          label: "Перерасход"
                        }),
                        _createVNode(_component_el_option, {
                          value: "overdraft_count",
                          label: "Перерасход шт."
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createVNode(_component_el_input_number, {
                        onChange: getData,
                        modelValue: countOnPage.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((countOnPage).value = $event)),
                        modelModifiers: { number: true },
                        controls: false,
                        min: 1
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createVNode(_component_el_checkbox, {
                        modelValue: showArchive.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showArchive).value = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "№",
                    width: "55"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(getRowTotalNumber(row)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "Название",
                    width: "210"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", _hoisted_32, _toDisplayString(row.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "tariff.display_title",
                    label: "Тариф",
                    width: "190"
                  }),
                  (!data.value.length)
                    ? (_openBlock(), _createBlock(_component_el_table_column, { key: 0 }))
                    : _createCommentVNode("", true),
                  (data.value.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(months.value, (month) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          key: month,
                          label: getFormattedDate(month),
                          "min-width": "150"
                        }, {
                          header: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_33, _toDisplayString(scope.column.label), 1)
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_component_el_table_column, {
                              key: `expenditures.${month}.month_report_count`,
                              prop: `expenditures.${month}.month_report_count`,
                              sortable: "custom",
                              label: "Отчеты",
                              "min-width": "65"
                            }, {
                              header: _withCtx((scope) => [
                                _createElementVNode("span", _hoisted_34, _toDisplayString(scope.column.label), 1)
                              ]),
                              default: _withCtx(({ row }) => [
                                _createElementVNode("span", _hoisted_35, _toDisplayString(row.expenditures[month]
                        ? row.expenditures[month].month_report_count
                        : 'no stats!'), 1)
                              ]),
                              _: 2
                            }, 1032, ["prop"])),
                            (_openBlock(), _createBlock(_component_el_table_column, {
                              key: `expenditures.${month}.dynamics`,
                              prop: `expenditures.${month}.dynamics`,
                              sortable: "custom",
                              label: "Динамика",
                              "min-width": "75"
                            }, {
                              header: _withCtx((scope) => [
                                _createElementVNode("span", _hoisted_36, _toDisplayString(scope.column.label), 1)
                              ]),
                              default: _withCtx(({ row }) => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(getExpenditureSubclass(row, month))
                                }, _toDisplayString(row.expenditures[month]
                        ? row.expenditures[month].dynamics
                          ? row.expenditures[month].dynamics + '%'
                          : '0%'
                        : 'no stats!'), 3)
                              ]),
                              _: 2
                            }, 1032, ["prop"])),
                            (extraColumns.value.indexOf('factual_price') != -1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: `expenditures.${month}.factual_price`,
                                  prop: `expenditures.${month}.factual_price`,
                                  sortable: "custom",
                                  label: "Стоимость",
                                  "min-width": "75"
                                }, {
                                  header: _withCtx((scope) => [
                                    _createElementVNode("span", _hoisted_37, _toDisplayString(scope.column.label), 1)
                                  ]),
                                  default: _withCtx(({ row }) => [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(getExpenditurePriceClass(row, month))
                                    }, _toDisplayString(getExpenditureDisplayPrice(row, month)), 3)
                                  ]),
                                  _: 2
                                }, 1032, ["prop"]))
                              : _createCommentVNode("", true),
                            (extraColumns.value.indexOf('overdraft_price') != -1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: `expenditures.${month}.overdraft_price`,
                                  prop: `expenditures.${month}.overdraft_price`,
                                  sortable: "custom",
                                  label: "Перерасход",
                                  "min-width": "85"
                                }, {
                                  header: _withCtx((scope) => [
                                    _createElementVNode("span", _hoisted_38, _toDisplayString(scope.column.label), 1)
                                  ]),
                                  default: _withCtx(({ row }) => [
                                    _createElementVNode("span", _hoisted_39, _toDisplayString(row.expenditures[month].overdraft_price), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["prop"]))
                              : _createCommentVNode("", true),
                            (extraColumns.value.indexOf('overdraft_count') != -1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: `expenditures.${month}.overdraft_count`,
                                  prop: `expenditures.${month}.overdraft_count`,
                                  sortable: "custom",
                                  label: "Перерасход шт.",
                                  "min-width": "100"
                                }, {
                                  header: _withCtx((scope) => [
                                    _createElementVNode("span", _hoisted_40, _toDisplayString(scope.column.label), 1)
                                  ]),
                                  default: _withCtx(({ row }) => [
                                    _createElementVNode("span", _hoisted_41, _toDisplayString(row.expenditures[month].overdraft_count), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["prop"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, loading.value]
          ])
        ]),
        _: 1
      }, 8, ["locale"]),
      _createVNode(_component_el_pagination, {
        "current-page": currentPage.value,
        "page-size": countOnPage.value,
        total: totalOrganizationCount.value,
        background: "",
        class: "statistic-table__pagination-item",
        layout: "prev, pager, next",
        onCurrentChange: handleChangeCurrentPage
      }, null, 8, ["current-page", "page-size", "total"])
    ])
  ]))
}
}

})